import { render, staticRenderFns } from "./amountRange.popup-chunk.vue?vue&type=template&id=b0e610a6&scoped=true"
import script from "./amountRange.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./amountRange.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e610a6",
  null
  
)

export default component.exports